export const taskss = [
    {
      label: "Phát âm",
      value: "phatam"
    },
    {
      label: "Trọng âm",
      value: "trongam"
    },
    {
      label: "Chọn đáp án đúng",
      value: "chondapandung"
    },
    {
      label: "Đồng nghĩa",
      value: "dongnghia"
    },
    {
      label: "Trái nghĩa",
      value: "trainghia"
    },
    {
      label: "Giao tiếp",
      value: "giaotiep"
    },
    {
      label: "Đọc điền từ",
      value: "docdientu"
    },
    {
      label: "Đọc hiểu đoạn văn",
      value: "dochieudoanvan"
    },
    {
      label: "Tìm lỗi sai",
      value: "timloisai"
    },
    {
      label: "Câu đồng nghĩa",
      value: "caudongnghia"
    },
    {
      label: "Kết hợp câu",
      value: "kethopcau"
    }
]

export const thematicss = [
    {
      label: "Cách phát âm đuôi -ed",
      value: "duoied"
    },
    {
      label: "Cách phát âm của nguyên âm",
      value: "nguyenamphuam"
    },
    {
      label: "Trọng âm của từ 2 âm tiết",
      value: "2amtiet"
    },
    {
      label: "Trọng âm của từ nhiều hơn 2 âm tiết",
      value: "nhieuamtiet"
    },
    {
      label: "Câu hỏi đuôi",
      value: "cauhoiduoi"
    },
    {
      label: "Giới từ",
      value: "gioitu"
    },
    {
      label: "So sánh kép",
      value: "sosanhkep"
    },
    {
      label: "Câu bị động",
      value: "caubidong"
    },
    {
      label: "Trật tự của tính từ",
      value: "trattutinhtu"
    },
    {
      label: "Thì quá khứ tiếp diễn",
      value: "qktd"
    },
    {
      label: "Liên từ (MC)",
      value: "lientu"
    },
    {
      label: "Phối hợp thì",
      value: "phoihopthi"
    },
    {
      label: "Rút gọn mệnh đề trạng ngữ",
      value: "mdtn"
    },
    {
      label: "Từ loại",
      value: "tuloai"
    },
    {
      label: "Cụm động từ",
      value: "cumdongtu"
    },
    {
      label: "Cụm từ cố định",
      value: "cumtucodinh"
    },
    {
      label: "Thành ngữ",
      value: "thanhngu"
    },
    {
      label: "Từ vựng (MC)",
      value: "tuvung1"
    },
    {
      label: "Từ đơn (C)",
      value: "tudon1"
    },
    {
      label: "Từ đơn (O)",
      value: "tudon2"
    },
    {
      label: "Cụm từ hoặc thành ngữ",
      value: "cumtuthanhngu"
    },
    {
      label: "Tình huống giao tiếp",
      value: "thgt"
    },
    {
      label: "Liên từ/trạng từ liên kết",
      value: "lientutrangtulk"
    },
    {
      label: "Đại từ quan hệ",
      value: "dtqh"
    },
    {
      label: "Từ vựng (FB)",
      value: "tuvung2"
    },
    {
      label: "Lượng từ",
      value: "luongtu"
    },
    {
      label: "Câu hỏi ý chính/tiêu đề tốt nhất",
      value: "mainidea"
    },
    {
      label: "Câu hỏi Đúng/Không đúng",
      value: "truenotrue"
    },
    {
      label: "Câu hỏi thông tin chi tiết",
      value: "ttct"
    },
    {
      label: "Câu hỏi quy chiếu",
      value: "quychieu"
    },
    {
      label: "Câu hỏi từ vựng",
      value: "tv"
    },
    {
      label: "Câu hỏi suy luận",
      value: "suyluan"
    },
    {
      label: "Thì của động từ",
      value: "thi"
    },
    {
      label: "Phép quy chiếu",
      value: "pqc"
    },
    {
      label: "Từ vựng (NC)",
      value: "tuvung3"
    },
    {
      label: "Chuyển đổi thì",
      value: "cdt"
    },
    {
      label: "Câu tường thuật",
      value: "ctt"
    },
    {
      label: "Động từ khuyết thiếu",
      value: "khuyetthieu"
    },
    {
      label: "Câu ước/câu điều kiện",
      value: "cauuoccaudieukien"
    },
    {
      label: "Đảo ngữ",
      value: "daongu"
    }
]

export const mixed = [
  {
    label: "Cách phát âm đuôi -ed",
    value: "duoied"
  },
  {
    label: "Cách phát âm của nguyên âm",
    value: "nguyenamphuam"
  },
  {
    label: "Trọng âm của từ 2 âm tiết",
    value: "2amtiet"
  },
  {
    label: "Trọng âm của từ nhiều hơn 2 âm tiết",
    value: "nhieuamtiet"
  },
  {
    label: "Câu hỏi đuôi",
    value: "cauhoiduoi"
  },
  {
    label: "Giới từ",
    value: "gioitu"
  },
  {
    label: "So sánh kép",
    value: "sosanhkep"
  },
  {
    label: "Câu bị động",
    value: "caubidong"
  },
  {
    label: "Trật tự của tính từ",
    value: "trattutinhtu"
  },
  {
    label: "Thì quá khứ tiếp diễn",
    value: "qktd"
  },
  {
    label: "Liên từ (MC)",
    value: "lientu"
  },
  {
    label: "Phối hợp thì",
    value: "phoihopthi"
  },
  {
    label: "Rút gọn mệnh đề trạng ngữ",
    value: "mdtn"
  },
  {
    label: "Từ loại",
    value: "tuloai"
  },
  {
    label: "Cụm động từ",
    value: "cumdongtu"
  },
  {
    label: "Cụm từ cố định",
    value: "cumtucodinh"
  },
  {
    label: "Thành ngữ",
    value: "thanhngu"
  },
  {
    label: "Từ vựng (MC)",
    value: "tuvung1"
  },
  {
    label: "Từ đơn (C)",
    value: "tudon1"
  },
  {
    label: "Từ đơn (O)",
    value: "tudon2"
  },
  {
    label: "Cụm từ hoặc thành ngữ",
    value: "cumtuthanhngu"
  },
  {
    label: "Tình huống giao tiếp",
    value: "thgt"
  },
  {
    label: "Thì của động từ",
    value: "thi"
  },
  {
    label: "Phép quy chiếu",
    value: "pqc"
  },
  {
    label: "Từ vựng (NC)",
    value: "tuvung3"
  },
  {
    label: "Chuyển đổi thì",
    value: "cdt"
  },
  {
    label: "Câu tường thuật",
    value: "ctt"
  },
  {
    label: "Động từ khuyết thiếu",
    value: "khuyetthieu"
  },
  {
    label: "Câu ước/câu điều kiện",
    value: "cauuoccaudieukien"
  },
  {
    label: "Đảo ngữ",
    value: "daongu"
  },
  {
    label: "Dạng bài: Đọc điền từ",
    value: "docdientu"
  },
  {
    label: "Dạng bài: Đọc hiểu đoạn văn",
    value: "dochieudoanvan"
  }
]